module.exports = __webpack_public_path__ + "static/past_around-6d5365f3a323ac26e4a3fad398adad64.png";